<template>
	<div>
		<el-form ref="form" :model="form" :rules="rules" size="small" label-position="right" label-width="100px">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="姓名" prop="personName">
						<el-input v-model.trim="form.personName"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="身份证号" prop="idCard">
						<el-input v-model.trim="form.idCard"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="等级" prop="professionalLevel">
						<el-select v-model.trim="form.professionalLevel" style="width: 100%;">
							<el-option
								v-for="item in dictionarys.djList"
								:key="item.dictcode"
								:label="item.dictionaryValues"
								:value="item.dictionaryValues"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="专业" prop="professionalProject">
						<el-select v-model.trim="form.professionalProject" style="width: 100%;" multiple collapse-tags>
							<el-option
								v-for="item in dictionarys.zyList"
								:key="item.dictcode"
								:label="item.dictionaryValues"
								:value="item.dictionaryValues"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import { validateIdCard } from '@/utils/jr-validate'
	import { queryCommonDictionary } from '@/api/dictionary/index'

	/**
	 * 技工人员表单组件
	 */
	export default {
		name: 'Technician',
		components: {},
		data() {
			return {
				form: {
					// 主键
					id: '',
					// 姓名
					personName: '',
					// 证件号码
					idCard: '',
					// 等级
					professionalLevel: '',
					// 专业
					professionalProject: []
				},
				rules: {
					personName: { required: true, message: '请输入', trigger: 'blur' },
					idCard: [
						{ required: true, message: '请输入', trigger: 'blur' },
						{ validator: validateIdCard, trigger: 'blur' }
					],
					professionalLevel: { required: true, message: '请输入', trigger: 'blur' },
					professionalProject: { required: true, message: '请输入', trigger: 'blur' }
				},
				// 字典集合
				dictionarys: {
					// 等级字典
					djList: [
						{
							dictionaryValues: '高级',
							dictcode: '高级'
						},
						{
							dictionaryValues: '中级',
							dictcode: '中级'
						},
						{
							dictionaryValues: '初级',
							dictcode: '初级'
						},
						{
							dictionaryValues: '无',
							dictcode: '无'
						}
					],
					// 专业字典
					zyList: []
				}
			}
		},
		created() {},
		mounted() {
			this.handleInitDictionary()
		},
		methods: {
			handleInitDictionary() {
				// 获取专业字典
				queryCommonDictionary({ dictionaryId: '10', cxType: '3' }).then(res => {
					this.dictionarys.zyList = res.data
				})
			},
			// 表单保存操作（每个列表对应的表单组件必须添加此方法，且必须同名）
			handleSaveInfo() {
				return new Promise(resolve => {
					this.$refs.form.validate(valid => {
						if (valid) {
							resolve(this.form)
						}
					})
				})
			}
		}
	}
</script>

<style scoped></style>
